export class ProductCategory
{
    id: number;
    enabled: boolean;
    name: string;
    icon: string;

    constructor()
    {
        this.id = 0;
        this.name = '';
        this.enabled = true;
        this.icon = '';
    }

    getId(): number
    {
        return this.id;
    }

    setId(id: number)
    {
        this.id = id;
    }

    getEnabled(): boolean
    {
        return this.enabled;
    }
    setEnabled(enabled: boolean)
    {
        this.enabled = enabled;
    }

    getName(): string
    {
        return this.name;
    }

    setName(productCategoryName: string)
    {
        this.name = productCategoryName;
    }

    getIcon(): string
    {
        return this.icon;
    }

    setIcon(iconUrl: string)
    {
        this.icon = iconUrl;
    }

}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/product-category.model.ts